import React from 'react';
import {useTranslation} from 'react-i18next';
import {Controller, UseFormReturn} from 'react-hook-form';
import ToggleSwitch from '../../../../../incase-domain/components/toggleSwitch/ToggleSwitch';
import HoverMenu from '../../../../components/common/HoverMenu';
import Button from '../../../../../incase-domain/components/button/Button';
import {IRunfileIdentification} from '../../../../../incase-domain/rooms/room.editor';

interface RunfileIdentificationProps {
    useForm: UseFormReturn;
}

function EditRoomIdentificationTab({useForm}: RunfileIdentificationProps): JSX.Element {
    const {t} = useTranslation();

    const {control, setValue, formState, watch} = useForm;
    const {errors} = formState;

    const identification: IRunfileIdentification = watch('identification');

    const [optionState, setOptionState] = React.useState<string>('');

    return (
        <div>
            <div className="c-editRoomModal__content_header">{t('roomsPage.runfileIdentification.groupIdentificationToggleLabel')}</div>

            <div className="l-group u-pt-2">
                <div key="data-collection-settings" className="l-group__item u-flex u-h-between u-v-center">
                    <div>{t('roomsPage.runfileIdentification.groupIdentificationToggleLabel')}</div>
                    <Controller
                        name="identification.groupIdentificationOn"
                        control={control}
                        render={({field}) => (
                            <ToggleSwitch
                                id="toggle-group-identification"
                                isOn={field.value}
                                handleToggle={() => field.onChange(!field.value)}
                            />
                        )}
                    />
                </div>

                {identification?.groupIdentificationOn && (
                    <div className="u-pl-3">
                        <div className="l-grid u-flex u-v-center u-mt-3">
                            <div className="l-col:4">
                                <label htmlFor="groupIdentificationLabel">
                                    {t('roomsPage.runfileIdentification.groupIdentificationLabel')}:
                                </label>
                            </div>
                            <div className="l-col:8">
                                <Controller
                                    name="identification.groupIdentificationLabel"
                                    control={control}
                                    render={({field}) => (
                                        <input
                                            id="groupIdentificationLabel"
                                            type="text"
                                            className="e-input is-sm"
                                            placeholder={t('roomsPage.runfileIdentification.groupIdentificationLabelPlaceholder')}
                                            {...field}
                                        />
                                    )}
                                />
                                <div className="error-msg u-flex u-h-right">
                                    {
                                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                        // @ts-ignore
                                        errors.identification?.groupIdentificationLabel && (
                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            // @ts-ignore
                                            <span>{t(errors.identification.groupIdentificationLabel.message)}</span>
                                        )
                                    }
                                </div>
                            </div>
                        </div>

                        {identification?.options && identification.options.length > 0 && (
                            <div className="l-grid u-flex u-v-center u-mt-3">
                                <div className="l-col:4">
                                    <label htmlFor="label">{t('roomsPage.runfileIdentification.options')}:</label>
                                </div>
                                <div className="l-col:8 u-flex flex-wrap">
                                    {identification.options.map((option, index) => (
                                        <HoverMenu
                                            key={index}
                                            style={{margin: '0.3rem 0.3rem 0 0', borderRadius: '0.2rem'}}
                                            onRemove={() => {
                                                const newOptions = identification?.options?.filter((_, i) => i !== index);
                                                setValue('identification.options', newOptions);
                                            }}
                                        >
                                            {option}
                                        </HoverMenu>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="l-grid u-flex u-v-center u-mt-3">
                            <div className="l-col:4">
                                <label htmlFor="option">{t('roomsPage.runfileIdentification.addOption')}:</label>
                            </div>
                            <div className="l-col:8 u-flex u-gap-4">
                                <div className="c-control u-flex}">
                                    <input
                                        id="option"
                                        type="text"
                                        className="e-input is-sm"
                                        placeholder={t('roomsPage.runfileIdentification.optionPlaceholder')}
                                        value={optionState}
                                        onChange={(e) => setOptionState(e.target.value)}
                                    />
                                </div>
                                <Button
                                    type="button"
                                    variant="solid"
                                    size="sm"
                                    color="secondary"
                                    leading="ph:plus"
                                    square
                                    onClick={() => {
                                        const newOptions = [...(identification?.options || []), optionState];
                                        setOptionState('');
                                        setValue('identification.options', newOptions);
                                        setOptionState('');
                                    }}
                                />
                            </div>
                            <div className="error-msg l-col:12 u-flex u-h-right">
                                {
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    errors.identification?.options && <span>{t(errors.identification.options.message)}</span>
                                }
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default EditRoomIdentificationTab;
